import type { Logger } from "@expert/logging";
import type { ExternalDevice } from "@expert/shared-types";
import { useDeviceInfoStore } from "./store";

export const setDeviceInfo = (devices: ExternalDevice[], logger: Logger) => {
    useDeviceInfoStore.getState().setDevices(devices);
    logger.child({ module: "setDeviceInfo" }).info({ devices }, "Device info set");
};
